import React, { Component, CSSProperties } from 'react';

import { ModalNewQuestionLayout } from './../index'
import { TypeQuestionsCategoriesEditor } from 'app_components/modules/academicComponentEditor/containers/academicComponentEditorFunctions';

interface IModalNewQuestionComponentProps {
    open: boolean
    inputData?: any
    disableModal?: boolean
    createWithClick?: boolean
    className?: string
    style?: CSSProperties
    only?: TypeQuestionsCategoriesEditor[]
    handleClose: (data?: any)=>void
}

interface IModalNewQuestionComponentState {}

class ModalNewQuestionComponent extends Component<IModalNewQuestionComponentProps, IModalNewQuestionComponentState> {
    render() {
        return (
            <ModalNewQuestionLayout
                {...this.props}
            />
        );
    }
}

export default ModalNewQuestionComponent;
